import * as React from 'react';
import {
  InputAdornment,
  OutlinedInput,
} from '@material-ui/core';
import styled from 'styled-components';

import SearchIcon from '@material-ui/icons/Search';
import CloseIcon from '@material-ui/icons/Close';

import { useDispatch } from 'react-redux';
import { IconButton } from '../atoms';
import { setSearchToken } from '../redux/slices/filterSlice';

const SearchPanel = ({
  placeholder = 'Search...',
  className,
  setSearchValue,
}: Props) => {
  const [value, setValue] = React.useState<string>('');
  const dispatch = useDispatch();
  const localSetValue = (token:string) => {
    setValue(token);
    dispatch(setSearchToken(token));
  };

  React.useEffect(() => {
    const searchData = localStorage.getItem('search');
    if (searchData) {
      setValue(searchData);
      setSearchValue(searchData);
    }
  }, []);
  return (
    <Search
      value={value}
      className={className}
      onChange={e => localSetValue(e.target.value)}
      onKeyDown={e =>
        e.key === 'Enter' ? setSearchValue(value) : null
      }
      placeholder={placeholder}
      endAdornment={
        <InputAdornment position="end">
          {value && (
            <IconButton
              size="small"
              edge="end"
              onClick={() => { setValue(''); setSearchValue(null); }}
            >
              <CloseIcon />
            </IconButton>
          )}
          <IconButton

            size="medium"
            edge="end"
            onClick={() =>
              value ? setSearchValue(value) : null
            }
          >
            <SearchIcon />
          </IconButton>
        </InputAdornment>
      }
    />
  );
};

const Search = styled(OutlinedInput)`
  min-height: 30px;
  background-color: var(--defaultBackground);
  width: 100%;
  border-radius: var(--radius-md);
  border: 1px solid var(--neutral-300);
  transition: border-color 0.15s ease, box-shadow 0.15s ease;

  .MuiOutlinedInput-input {
    padding: 6px 14px 7px 14px;
    border: none;
    outline: none;
    box-shadow: none;
  }

  .MuiOutlinedInput-input:focus,
  .MuiOutlinedInput-input:focus-visible {
    border: none;
    outline: none;
    box-shadow: none;
  }

  & .MuiOutlinedInput-notchedOutline,
  &.Mui-focused .MuiOutlinedInput-notchedOutline,
  &.Mui-error .MuiOutlinedInput-notchedOutline {
    border: none !important;
    box-shadow: none !important;
  }

  &:hover {
    border-color: var(--neutral-400);
  }

  &.Mui-focused {
    border-color: var(--primary-600);
    box-shadow: var(--shadow-focus);
  }
`;

interface Props {
  placeholder?: string;
  className?: string;
  setSearchValue: (data: string) => void;
}

export default SearchPanel;
